import { InjectionToken } from '@angular/core';
import { QueryResult } from '../query-result';

export const QUERY_SERVICE_TOKEN = new InjectionToken<IQueryService>(
    'QUERY SERVICE TOKEN'
);

/**
 * Service responsible for running data queries.
 */
export interface IQueryService {
    runQuery(query: string): Promise<QueryResult>;
}
